import { ShippingMethodEnum } from '../../../../app-shared/models/steps/step-shipping.interface';
const ɵ0 = ShippingMethodEnum.Home, ɵ1 = ShippingMethodEnum.Shop;
export const ShippingMethodTypes = [
    {
        id: ɵ0,
        title: 'ENTITY.SHIPPING-METHOD.HOME.TITLE'
    },
    {
        id: ɵ1,
        title: 'ENTITY.SHIPPING-METHOD.SHOP.TITLE'
    }
];
export { ɵ0, ɵ1 };
